import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const EMPTY = { body: "", updated_at: null };

export const useAgencyNote = (API, clientId, start, end, slot) => {
  const [note, setNote] = useState(EMPTY);

  useEffect(() => {
    if (!start || !end) { setNote(EMPTY); return; }
    let cancelled = false;
    axios.get(`${API}/agency-notes`, { params: { client_id: clientId, report_start: start, report_end: end, slot } })
      .then((r) => { if (!cancelled) setNote(r.data || EMPTY); })
      .catch(() => { if (!cancelled) setNote(EMPTY); });
    return () => { cancelled = true; };
  }, [API, clientId, start, end, slot]);

  const save = async (body) => {
    // Edit the note where it lives (it may be inherited from an overlapping period)
    const rs = note.report_start || start;
    const re = note.report_end || end;
    try {
      const r = await axios.put(`${API}/agency-notes`, { client_id: clientId, report_start: rs, report_end: re, body, slot });
      setNote(r.data || EMPTY);
      toast.success(body ? "Saved" : "Cleared");
      return true;
    } catch {
      toast.error("Couldn't save");
      return false;
    }
  };

  return [note, save];
};
